import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ChartSerie} from '../../commons/types';
import {ChartLegendBadge} from './chartLegendBadge';

/*
 * Const.
 */

/*
 * Props.
 */

export interface ChartLegendProps<T> {
  series: ReadonlyArray<ChartSerie<T>>;
}

/*
 * Style.
 */

const SerieLegend = styled.div`
  display: flex;
  align-items: center;
`;

const SerieLegendItem = styled.div`
  display: flex;
  align-items: center;
`;

const SerieLabel = styled.span`
  color: ${(p) => p.theme.greys.shade90};
  margin-right: 20px;
  font-size: ${fontSizes.verySmall};
`;

/*
 * Component.
 */

export const ChartLegend = <T,>(props: ChartLegendProps<T>): ReturnType<FC> => {
  const {series} = props;
  return (
    <SerieLegend>
      {series.map((serie, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <SerieLegendItem key={index}>
          <ChartLegendBadge color={serie.color} />
          <SerieLabel>{serie.label}</SerieLabel>
        </SerieLegendItem>
      ))}
    </SerieLegend>
  );
};
